import { isPlatformSuperAdmin } from 'pure-js/libs/isSuperUser'
import type { User } from 'pure-js/types/User'

export function isPlatformSuperUser(user: User | null | undefined): boolean {
  return isPlatformSuperAdmin(user)
}
